<template>
  <m-base
    :showTopBorder="pattern.showTopBorder"
    :showRightBorder="pattern.showRightBorder"
    :showBottomBorder="pattern.showBottomBorder"
    :showLeftBorder="pattern.showLeftBorder"
    :showBorderRadius="pattern.showBorderRadius"
    :showTopPadding="pattern.showTopPadding"
    :showRightPadding="pattern.showRightPadding"
    :showBottomPadding="pattern.showBottomPadding"
    :showLeftPadding="pattern.showLeftPadding"
    :boxType="pattern.boxType"
    :showHeader="false"
    :showPadding="false"
  >
    <div slot="content">
      <!-- 标题栏和状态栏占位符 -->
      <div class="titleNdiv-placing" :style="{backgroundColor: pattern.backgroundColor}">
        <van-image lazy-load v-if="params.showImage&&data.src" :src="data.src" @click="navToDetailPage" />
        <div class="mp-search-box" @click="navToSearchPage">
          <input
            class="ser-input"
            :style="{backgroundColor:params.inputBackgroundColor,color:params.placeholderColor}"
            type="text"
            :value="params.placeholder"
            disabled
          />
        </div>
      </div>
    </div>
  </m-base>
</template>

<script >
export default {
  props: {
    params: {
      type: Object,
      default: () => {
        return {
          placeholder: '请输入关键字搜索',
          inputBackgroundColor: 'rgba(248, 248, 248,1)',
          placeholderColor: 'rgba(149, 149, 149,1)',
          showImage: false,
        }
      }
    },
    data: {
      type: Object,
      default: () => {
        return {
          src: 'https://res.zhifu88.cn/alachuang/755320200508174011/default.png',
          navTo: ''
        }
      }
    },
    pattern: {
      type: Object,
      default: () => {
        return {
          showTopBorder: false,
          showRightBorder: false,
          showBottomBorder: true,
          showLeftBorder: false,
          showBorderRadius: false,
          showLeftPadding: false,
          showRightPadding: false,
          showTopPadding: false,
          showBottomPadding: false,
          boxType: 'block',
          backgroundColor: 'rgba(255,255,255,1)',
        }
      }
    },
  },
  data () {
    return {

    };
  },
  methods: {
    navToSearchPage () {
      this.$router.push('/pages/search/search')
    },
    navToDetailPage () {
      let navTo = this.data.navTo
      if (navTo) {
        if (navTo.indexOf('http') > -1) {
          window.location.href = navTo
        } else {
          this.$router.push(this.$uitl.getPathQuery(navTo))
        }
      }
    },
  }
}
</script>

<style lang="scss" scoped>
//搜索栏
.titleNdiv-placing {
  position: relative;
  min-height: 50px;
  box-sizing: content-box;

  .mp-search-box {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    width: 100%;
    padding: 10px 20px 10px 20px;

    .ser-input {
      flex: 1;
      height: 36px;
      line-height: 36px;
      text-align: center;
      font-size: 14px;
      color: $font-color-base;
      border-radius: 18px;
      // background-color: rgb(248, 248, 248);
    }
  }
}
</style>
